import { useTranslation } from 'react-i18next';

const AboutPageHeader = () => {
  const { t } = useTranslation();
  return (
    <section className='grid place-items-center bg-[url("./assets/headerAboutUsContact.png")] bg-cover bg-no-repeat px-[1rem] py-[7.1rem]'>
      <h1 className=' text-[3.4rem] font-medium leading-[7.6875rem] text-primary-yellow sm:text-[5.5rem]'>{t('aboutUs')}</h1>
    </section>
  );
};

export default AboutPageHeader;
